<template>
	<div>
		<el-dialog title="學員資料匯入"
             :visible.sync="dialogImportFormVisible"
             :width="dw">
	    <el-form ref="importForm" label-width="100px">
	      <div style="text-align: center;" v-if="importing">
	        <i class="el-icon-loading" style="font-size:22px"></i>匯入處理中...
	      </div>
	      <el-upload drag
	                 class="avatar-uploader"
	                 :show-file-list="false"
	                 :action="importAction"
	                 :on-progress="avatarProgress"
	                 :on-change="avatarChanged"
	                 :on-success="handleImportSuccess"
	                 :before-upload="beforeImport">
	        <i class="el-icon-plus avatar-uploader-icon"></i>
	        <div slot="tip" class="el-upload__tip">限上傳 xlsx、xls 格式</div>
	      </el-upload>
	    </el-form>
	  </el-dialog>
	
		<el-card class="box-card">
			<el-row :gutter="20">
		    <el-col :xs="24" :sm="24" :lg="6">
		    	<el-main>
	          <el-select
					    v-model="value"
					    multiple
					    filterable
					    remote
					    reserve-keyword
					    placeholder="輸入學員中/英文名"
					    :remote-method="remoteMethod"
					    :loading="loading">
					    <el-option
					      v-for="item in users"
					      :key="item.id"
					      :label="`${item.username}(${item.engName})`"
					      :value="item.id">
					    </el-option>
					  </el-select>

	        	<div class="mt-20">
	        		<el-button type="primary" size="mini" @click="saveData('dataForm')">新增學員 >></el-button>
	        	</div>
		       </el-main>
		    </el-col>
		    <el-col :xs="24" :sm="24" :lg="18">
		    	<el-main>
		    		<div class="text-right">
	        		<el-button icon="el-icon-tickets" type="primary" size="mini" @click.prevent="dialogImportFormVisible = true">匯入學員資料</el-button>
	        	</div>
		    		<el-table :data="tableData" empty-text="目前尚無資料" stripe header-row-class-name="headerStyle">
		          <el-table-column width="70">
	              <template slot-scope="scope">
	                <img v-if="scope.row.avatar" :src="showImage(scope.row.avatar)" class="display-avatar">
	              </template>
	            </el-table-column>
	            <el-table-column prop="empno" label="帳號">
		          </el-table-column>
		          <el-table-column prop="username" label="中文名" width="100">
		          </el-table-column>
		          <el-table-column prop="engName" label="英文名">
		          </el-table-column>
		          <el-table-column prop="studentCertNo" label="證書編號">
		          </el-table-column>
		          <el-table-column :label="$t('action.name')" width="250">
		            <template slot-scope="scope">
		              <el-popconfirm
		                  class="ml-10 popconfirm-bg"
		                  :title="$t('message.delete_confirm')"
		                  :confirm-button-text="$t('buttons.confirm')"
		                  :cancel-button-text="$t('buttons.cancel')"
		                  icon="el-icon-info"
		                  icon-color="red"
		                  @confirm="handleDelete(scope.row.id)"
		              >
		                <el-button size="mini"　type="danger" slot="reference">{{$t('buttons.delete')}} <i class="el-icon-delete"></i></el-button>
		              </el-popconfirm>

		              <el-popconfirm
		                  class="ml-10 popconfirm-bg"
		                  title="通知此學員"
		                  :confirm-button-text="$t('buttons.confirm')"
		                  :cancel-button-text="$t('buttons.cancel')"
		                  icon="el-icon-info"
		                  icon-color="red"
		                  @confirm="handleNotify(scope.row)"
		              >
		                <el-button size="mini"　type="warning" slot="reference">證書下載通知 <i class="el-icon-bell"></i></el-button>
		              </el-popconfirm>

		            </template>
		          </el-table-column>

		        </el-table>
		        <AppPagination :pageNum="pageNum" :pageSize="pageSize" :total="total" @pageChange="pageChange" />
		      </el-main>
		    </el-col>
		  </el-row>
		</el-card>

	</div>
</template>

<script>

import AppPagination from '@/components/pagination/AppPagination'
import {mapState} from 'vuex'

export default {
	name: 'CourseStudentInfo',
	components:{
		AppPagination
	},
	computed: {
    ...mapState('login', ['userInfo']),
  },
	data(){
		return {
			dialogImportFormVisible:false,
			importAction: '',
			importing: false,
			dw: '40%',

			courseId:'',
			loading:false,
			value:[],
			users:[],
			tableData:[],

			pageNum: 1,
      pageSize: 10,
      total: 0
		}
	},
	methods:{
		beforeImport(file) {
      const isExcel = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel');
      if (!isExcel) {
        this.$message.error('限上傳 xlsx、xls 格式');
      }
      return isExcel
    },
		avatarProgress(){
      this.importing = true
    },
    avatarChanged(){
      this.importing = false
    },
		handleImportSuccess(res, file) {
      this.dialogImportFormVisible = false
      if (res.code === '200') {
        
        this.value = []
				this.users = []
        this.loadData()
        this.showResult('success', '匯入完成')
          
      } else {
        this.showResult('error', res.message)
      }
    },
		pageChange(val) {
      this.pageNum = val
      this.loadData()
    },
    loadData(){
    	let query = {
				courseId: this.courseId,
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
    	this.request.get("/course/students", {params: query} ).then(res => {
				if (res.code === '200') {
          this.tableData = res.data.records
          this.total = res.data.total
        } else {
          this.showResult('error', '無法取得課程學員')
        }
      })
    },
		remoteMethod(kw){
			console.log('remote:', kw)
			this.loading = true
			let query = {
				courseId: this.courseId,
				keyword: kw
			}
			this.request.get("/user/unselected", { params: query } ).then(res => {
				this.loading = false
        if (res.code === '200') {
          this.users = res.data
        } else {
          this.showResult('error', '查詢學員資料失敗')
        }
      })
		},
		saveData(){

			let data = {
				studentIds : this.value,
				courseId: this.courseId
			}
			if (this.value.length > 0) {
				this.request.post("/course/student/selected", data ).then(res => {
					if (res.code === '200') {
						this.value = []
						this.users = []
	          this.loadData()
	          this.showResult('success', this.$t('action.save_success'))
	        } else {
	          this.showResult('error', this.$t('action.save_error', {err: res.message}))
	        }
	      })
			}
			
		},
		handleDelete(id){
			this.request.delete("/course/student/" + id ).then(res => {
				if (res.code === '200') {
          this.loadData()
          this.showResult('success', this.$t('action.delete_success'))
        } else {
          this.showResult('error', this.$t('action.delete_error', {err: res.message}))
        }
      })
		},
		handleNotify(row) {
			let form = {
				courseId: this.courseId,
				empno: row.empno
			}
			this.request.post("/course/student/notify_single", form).then(res => {
				if (res.code === '200') {
          this.showResult('success', "通知成功")
        } else {
          this.showResult('error', "通知失敗")
        }
      })
		}
	},
	mounted(){
		this.courseId = parseInt(this.$route.params.cid)
		this.importAction = '/api/course/student/imp?token=' + this.userInfo.token + "&courseId="+this.courseId
		
		this.loadData()
	}
}

</script>

<style scoped>
.display-avatar {
  width: 55px;
  height: 55px;
  border-radius: 999px;
  object-fit: cover;
  margin-right: 10px;
}
</style>


